import { server, toastr } from '@/services/'

const state = {
  isFetching: false,
  items: []
}

const mutations = {
  setIsFetching(state, payload) {
    state.isFetching = payload
  },
  setItems (state, payload) {
    state.items = payload
  }
}

const getters = {
  getRole: (state) => (code) => {
    return state.items.find(role => role.CODE === code)
  },
  getRoleName: (state) => (code) => {
    let role = state.items.find(role => role.CODE === code)
    if (!role) {
      return ''
    }
    return role.NAME
  },
  getModuleRoles: (state) => (module) => {
    switch (module) {
      case 'VRMS':
      case 'IACMS':
      case 'DRMS':
      case 'MRS':
      case 'CCPL - RVA':
        return state.items.filter(role => ['USRL-2', 'USRL-5'].includes(role.CODE))
      case 'CLEANING':
      case 'VMTS Toyota PH':
        return state.items.filter(role => ['USRL-2', 'USRL-3'].includes(role.CODE))
      case 'CCPL - REPORTING':
      case 'CCPL - FLEET PARTNER':
        return state.items.filter(role => ['USRL-2', 'USRL-5'].includes(role.CODE))
      case 'OPS - VMTS REVAMP':
      case 'CCPL - VMTS v2':
        return state.items.filter(role => ['USRL-2', 'USRL-6', 'USRL-8'].includes(role.CODE))
      case 'OPS - FCS':
        return state.items.filter(role => ['USRL-2', 'USRL-7'].includes(role.CODE))
      default: return state.items.filter(role => role.CODE === 'USRL-2')
    }
  }
}

const actions = {

  getAll ({ commit }) {
    commit('setIsFetching', true)
    return new Promise((resolve, reject) => {
      server.get('/getUserRoles').then(
        resp => {
          commit('setIsFetching', false)
          commit('setItems', resp.data.msgContent.data)
          resolve(true)
        },
        err => {
          commit('setIsFetching', false)
          reject(err.response)
        }
      )
    })
  },
  upsertItem({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      server.post('/upsertUserRoles', payload.reqBody).then(
        resp => {
          if (payload.mode === 'Add') {
            toastr.addSuccess()
          } else {
            toastr.updateSuccess()
          }
          dispatch('getAll')
          resolve(true)
        },
        err => {
          toastr.serverError()
          reject(err.response)
        }
      )
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
